import { useSelector } from 'react-redux';

const useCanEditOrders = (): boolean => {
  const { user } = useSelector((state: any) => state.user);

  return user?.permission?.canEditOrders?.canMutate === true;
};

export default useCanEditOrders;
